<template>
  <v-app class="app-layout">
    <!-- Header (make sure v-app-bar in AppHeader has the 'app' prop) -->
    <AppHeader />

    <!-- Add location + a close action -->
    <v-snackbar v-model="snack.show" :color="snack.color" location="top right" timeout="3500">
      {{ snack.msg }}
      <template #actions>
        <v-btn variant="text" @click="snack.show = false">Close</v-btn>
      </template>
    </v-snackbar>

    <!-- Main content fills the remaining height -->
    <v-main class="flex-1">
      <router-view :key="$route.fullPath" />
    </v-main>

    <!-- Footer pinned to bottom -->
    <v-footer class="footer-compact bg-dark text-white" height="auto">
      <v-container max-width="1200" class="py-4">
        <v-row>
          <!-- Brand / About -->
          <v-col cols="12" md="4" class="mb-3">
            <div class="text-h6 font-weight-bold mb-1">UnBooked</div>
            <p class="text-subtitle-1 mb-2 opacity-80">
              Turning unused space into unforgettable escapes.
            </p>
            <div class="d-flex ga-1">
              <v-btn icon variant="text" size="x-small" class="text-white" :to="{ path: '/about' }">
                <v-icon size="25">mdi-information-outline</v-icon>
              </v-btn>
              <v-btn icon variant="text" size="x-small" class="text-white" href="https://facebook.com" target="_blank">
                <v-icon size="25">mdi-facebook</v-icon>
              </v-btn>
              <v-btn icon variant="text" size="x-small" class="text-white" href="https://instagram.com" target="_blank">
                <v-icon size="25">mdi-instagram</v-icon>
              </v-btn>
              <v-btn icon variant="text" size="x-small" class="text-white" href="https://x.com" target="_blank">
                <v-icon size="25">mdi-twitter</v-icon>
              </v-btn>
            </div>
          </v-col>

          <!-- Quick Links -->
          <v-col cols="6" sm="4" md="3" class="mb-3">
            <div class="text-h6 font-weight-bold mb-1">Pages</div>
            <v-list bg-color="transparent" density="compact" class="footer-list py-0">
              <v-list-item :to="{ path: '/' }" title="Home" />
              <v-list-item :to="{ path: '/deals' }" title="Deals" />
              <v-list-item :to="{ path: '/about' }" title="About" />
              <v-list-item :to="{ path: '/contact' }" title="Contact" />
              <v-list-item :to="{ path: '/agent' }" title="Travel Professionals" />
            </v-list>
          </v-col>

          <!-- Contact -->
          <v-col cols="6" sm="8" md="5" class="mb-3">
            <div class="text-h6 font-weight-bold mb-1">Contact</div>
            <div class="d-flex align-center mb-3">
              <v-icon size="25" class="mr-4">mdi-email-outline</v-icon>
              <a class="text-white footer-link text-subtitle-1"
                href="mailto:go@unbookedtravel.com">go@unbookedtravel.com</a>
            </div>
            <div class="d-flex align-center">
              <v-icon size="25" class="mr-4">mdi-phone</v-icon>
              <a class="text-white footer-link text-subtitle-1" href="tel:+15082034662">(508) 203-4662</a>
            </div>
          </v-col>
        </v-row>

        <v-divider class="my-2" color="white" opacity="0.1" />

        <div class="d-flex flex-wrap justify-space-between align-center text-subtitle-1 opacity-70 py-1">
          <div>&copy; {{ year }} UnBooked</div>
          <div class="d-flex ga-3">
            <router-link class="text-white footer-link " to="/terms">Terms</router-link>
            <router-link class="text-white footer-link" to="/privacy">Privacy</router-link>
          </div>
        </div>
      </v-container>
    </v-footer>



  </v-app>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'

export default {
  name: 'App',
  components: { AppHeader },
  data() {
    return { 
      year: new Date().getFullYear(),
      snack: { show: false, color: 'success', msg: '' }
    }
  },
  mounted() {
    this.showFlashFromSession()
  },
  methods: {
    showFlashFromSession() {
      const raw = sessionStorage.getItem('flash')
      if (!raw) return
      try {
        const { msg, color } = JSON.parse(raw)
        this.snack = { show: true, color: color || 'success', msg: msg || 'Done!' }
      } catch (e) {
        console.error('Invalid flash payload:', e)
      } finally {
        sessionStorage.removeItem('flash')
      }
    }
  }
}
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
}

.app-layout {
  min-height: 100dvh;
  /* full viewport height, modern units */
  display: flex;
  flex-direction: column;
}

/* Let v-main expand; no need to set overflow here unless you want a scrolling pane */
.flex-1 {
  flex: 1 1 auto;
}

.footer-compact {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.footer-list .v-list-item {
  min-height: 28px !important;
  /* tighter rows */
}

.text-body-3 {
  font-size: 0.75rem;
  /* ~12px */
  line-height: 1.3;
}

.footer-link {
  text-decoration: none;
}

.footer-link:hover {
  text-decoration: underline;
}
</style>